import globalAgent from '../../agent';
import { ProjectSubscription, Subscription } from '../../types/Subscription';

class ProjectSubscriptionsService {
    private baseUrl = '/subscriptions/project';

    async createPayment(data: {
        project_id: number;
        plan_id: number;
        duration_months: number;
        promo_code?: string;
        use_bonus_points?: number;
    }) {
        const response = await globalAgent.post(`${this.baseUrl}/create-payment/`, data);
        return response.data;
    }

    async getProjectSubscription(projectId: number): Promise<ProjectSubscription> {
        const response = await globalAgent.get(`${this.baseUrl}/${projectId}/subscription/`);
        return response.data;
    }

    async cancelProjectSubscription(projectId: number) {
        const response = await globalAgent.post(`${this.baseUrl}/cancel/`, { project_id: projectId });
        return response.data;
    }

    async getSubscriptionPlans(): Promise<Subscription[]> {
        const response = await globalAgent.get('/subscriptions/plans/');
        return response.data;
    }
}

export const projectSubscriptionsService = new ProjectSubscriptionsService();
